import styled from 'styled-components';
import { Form } from '../../Studyroom/AuctionForm';
import { useState } from 'react';
import StudyroomService from '../../../service/studyroom/Studyroom';

interface Props {
  file: Form;
  onClose: () => void;
}

function ExportModal({ file, onClose }: Props) {
  const [hwp, setHwp] = useState(false);
  const [word, setWord] = useState(false);

  const downloadFile = (idx: number, fileType: 'hwp' | 'doc') => {
    // try {
    //   const link = document.createElement('a');
    //   link.href = StudyroomService.downloadHref(idx, fileType);
    //   link.download = '';
    //   document.body.appendChild(link);
    //   link.click();
    //   document.body.removeChild(link);
    // } catch (err) {
    //   console.log(err);
    // }
    const url = StudyroomService.downloadHref(idx, fileType);
    window.open(url, '_blank');
  };

  return (
    <ModalOverlay
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClose();
      }}
    >
      <Container onClick={(e) => e.stopPropagation()}>
        <Header>
          <div />
          <Title>내보내기</Title>
          <img
            src="/assets/images/close/close_black-big.svg"
            width={24}
            height={24}
            onClick={onClose}
          />
        </Header>
        <Content>
          <FileName>{file.title}</FileName>
          <FileBox>
            <FileDiv onClick={() => setHwp((prev) => !prev)}>
              <img
                src={
                  hwp
                    ? '/assets/images/check/check-blue-on.svg'
                    : '/assets/images/check/check-blue-off.svg'
                }
                alt=""
                width={20}
                height={20}
              />
              한글파일
            </FileDiv>
            <FileDiv onClick={() => setWord((prev) => !prev)}>
              <img
                src={
                  word
                    ? '/assets/images/check/check-blue-on.svg'
                    : '/assets/images/check/check-blue-off.svg'
                }
                alt=""
                width={20}
                height={20}
              />
              워드파일
            </FileDiv>
          </FileBox>
        </Content>
        <ButtonBox>
          <Button
            disable={!hwp && !word}
            onClick={() => {
              if (hwp) {
                downloadFile(file.idx, 'hwp');
              }
              if (word) {
                downloadFile(file.idx, 'doc');
              }
            }}
          >
            다운로드
          </Button>
        </ButtonBox>
      </Container>
    </ModalOverlay>
  );
}

export default ExportModal;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

const Container = styled.div`
  width: 100%;
  background-color: #ffffff;
  overflow: hidden;
  box-shadow: 0px -4px 15px 0px #8d95a340;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  padding: 16px;
  justify-content: space-between;
  align-items: center;

  img {
    cursor: pointer;
  }
`;

const Title = styled.div`
  font-weight: 700;
  font-size: 18px;
  text-align: center;
  color: #222222;
`;

const Content = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const FileBox = styled.div`
  display: flex;
  flex-direction: column;
`;

const FileName = styled.div`
  font-weight: 500;
  font-size: 16px;
`;

const FileDiv = styled.div`
  display: flex;
  gap: 8px;
  padding-top: 8px;
  padding-bottom: 8px;
  cursor: pointer;

  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #616161;
`;

const ButtonBox = styled.div`
  padding-top: 16px;
  padding-right: 16px;
  padding-bottom: 40px;
  padding-left: 16px;
`;

const Button = styled.button<{ disable?: boolean }>`
  border-radius: 8px;
  padding: 12px 28px;
  text-align: center;
  background-color: ${({ disable }) => (disable ? '#FAFAFB' : '#008AFF')};
  cursor: pointer;
  border: none;
  width: 100%;

  font-weight: 500;
  font-size: 16px;
  color: ${({ disable }) => (disable ? '#37383C29' : '#ffffff')};
`;
